// validators/boolean.ts
import { assertValidation } from "../errors.mjs";
import { AbstractValidator, makeValidatorFactory } from "../types.mjs";
var BooleanValidator = class extends AbstractValidator {
  fromString;
  constructor(constraints = {}) {
    super();
    const { fromString = false } = constraints;
    this.fromString = fromString;
  }
  validate(value) {
    if (typeof value === "string" && this.fromString) {
      const string = value.toLowerCase();
      const parsed = string === "true" ? true : string === "false" ? false : void 0;
      assertValidation(parsed !== void 0, "Boolean can not be parsed from string");
      value = parsed;
    }
    assertValidation(typeof value === "boolean", 'Value is not a "boolean"');
    return value;
  }
};
function booleanValidatorFactory(constraints) {
  return new BooleanValidator(constraints);
}
var boolean = makeValidatorFactory(new BooleanValidator(), booleanValidatorFactory);
export {
  BooleanValidator,
  boolean,
  booleanValidatorFactory
};
//# sourceMappingURL=boolean.mjs.map
